import moment from "moment";
import React, { Children, Component } from "react";
import Selector from "../../components/dropdown/commonDropdown/Selector";
import BatchJobExtractionServices from "../../services/axiosServices/apiServices/BatchJobExtractionServices";
import FinanceServices from "../../services/axiosServices/apiServices/FinanceServices";
import SwalServices from "../../services/swalServices/SwalServices";
import { saveAs } from "file-saver";
import PageLoader from "../../components/common/pageLoader/PageLoader";
import ValidationText from "../../utils/validation/ValidationText";
import { validate ,isValidForm} from "../../utils/validation/CommonValidator";
import { CommonValidationMessages } from "../../utils/Messages";

export default class ChapterMemberCountTablesReports extends Component {
    constructor(props) {
        super(props);
        this.batchJobExtractionServices = new BatchJobExtractionServices();
        this.financeServices = new FinanceServices();

        this.swalServices = new SwalServices();
        this.state = {
            chaptercategoryData:[],
            membershipcategorydata:[],
            organisationroledata:[]
,            pagination: {
                pageNo: 1,
                pageSize: 10,
                orderByColumn: "CreatedAt",
                orderFlag: 0,
                searchText: "",
                organisationRoleStatus:0,
                selectedChapterCategory: [],
                selectedMembershipCategory: [],
            },
            statusList:[
                {
                    value: 1,
                    label: "All",
                },
                {
                    value: 2,
                    label: "Active",
                },
                {
                    value: 3,
                    label: "Active-New",
                },
                {
                    value: 4,
                    label: "Inactive",
                },
                {
                    value: 5,
                    label: "Inactive-New",
                },
                {
                    value: 6,
                    label: "Ex-Member",
                },
                {
                    value: 7,
                    label: "New Application",
                },
               
            ],
            ChapterMemberCountTablesReportsRequest: {
                startDate: "",
                endDate: "",
                memberStatus: ""
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRule: {
                startDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace("{0}", "Start date for transaction report"),
                    },
                ],
                endDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace("{0}", "End date for transaction report"),
                    },
                    {
                        type: "minEndDate",
                        minEndDate: "startDate",
                        message: CommonValidationMessages.SelectRequired.replace("{0}", "greater end date")
                    }
                ],
                memberStatus: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace("{0}", "Member status"),
                    },
                ],
            },

            statusData:[],
            chapterList: [],
            organisationRoleList:[],
            membershipCategoryList: [],
            isLoading: false,
            currentDate: new Date(),
            organisationRoleReportList: [],
            totalCount: 0,

        };
    }

    componentDidMount = () => {
        this.getAllChapterMemberTableReportList();
        this.getAllDropdownForOrganizationReportRole();

    }

    getAllChapterMemberTableReportList = () => {
        this.setState({ isLoading: true });
        let pagination = { ...this.state.pagination };
        this.batchJobExtractionServices.getAllChapterMemberTableReportList(pagination).then((response) => {
            if (response.statusCode === 200 && response.responseItem != null) {
                let details = response.responseItem.responseContent.itemList;
              
                this.setState({
                    organisationRoleReportList: details,
                    totalCount: response.responseItem.responseContent.totalCount,
                })
            }
            else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        });
    }


    handleChangeInDropdown(selected, drpIdentity) {
        if (drpIdentity === "status") {
            let dataArr = this.state.ChapterMemberCountTablesReportsRequest
            if (selected.value > 0) {
                dataArr.memberStatus = selected.label;
            } else {
                dataArr.memberStatus = "";
            }
            this.setState({ ChapterMemberCountTablesReportsRequest: dataArr }, () => {
                this.validateField("memberStatus");
            })
        }
    }
    

  getAllDropdownForOrganizationReportRole = () => {
    this.financeServices.getAllDropdownsForOrganisationRoleReports()
        .then(response => {
            if (response.statusCode === 200 && response.responseItem) {
                console.log("Response:", response);
                let chapterList = response.responseItem.responseContent.filter(
                    (drp) => drp.dropdownName === "Chapters"
                  );
                 
                //   let statusList = response.responseItem.responseContent.filter(
                //     (drp)=> drp.dropdownName ==="Status"
                //   );

                  chapterList = chapterList.map((p) => ({
                    value: p.id,
                    label: p.name,
                  }));
                //   statusList = statusList.map((p)=>({
                //     value : p.id,
                //     label : p.name
                //   }))
                  this.setState({
                    chapterList: chapterList,
                    // sstatusList : statusList
                  }, () => this.getAllChapterMemberTableReportList());
            } else {
                this.getAllChapterMemberTableReportList();
                this.swalServices.Error(response.message);
             
            }
        })
        .catch(error => {
            // Handle any errors that occurred during the request
            console.error("An error occurred while fetching dropdowns:", error);
        });
};
    


    generateChapterMemberCountTableReport = () => {
        if (this.state.currentDate) {
            this.setState({ isLoading: true });
           
           
              let request = {};
              request.startDate = moment(this.state.ChapterMemberCountTablesReportsRequest.startDate).format("DD MMM YYYY");
              request.endDate = moment(this.state.ChapterMemberCountTablesReportsRequest.endDate).format("DD MMM YYYY");
              request.memberStatus = this.state.ChapterMemberCountTablesReportsRequest.memberStatus;
            let isValidateAllFields = this.isValidateAllFields()
            if (isValidateAllFields === true) {
            this.batchJobExtractionServices.generateChapterMemberCountTableReport(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem != null) {
                    this.swalServices.Success("Chapter Member count record generated successfully.");
                    this.getAllChapterMemberTableReportList();
                }
                else if (response.statusCode === 409) {
                    this.swalServices.Error(response.message);
                }
                else {
                    this.swalServices.Error(response.message);
                }
                this.setState({ isLoading: false });
            });
        }
        }
        else {
            this.swalServices.Alert('Please select date');
        }
    }



    downloadSheetByChapterMemberTableReportId = (organisationRoleReportId) => {
        this.setState({ isLoading: true });
        let request = [];
        request.push(organisationRoleReportId);
        this.batchJobExtractionServices.downloadSheetByChapterMemberTableReportId(request).then((response) => {
            if (response.status === 200 && response.data != null) {
                let blob = new Blob([response.data])
                saveAs(blob, `ChapterMemberTableReport` + ".xlsx");
            }
            else {
                this.swalServices.Error(response.message);
            }
            this.setState({ isLoading: false });
        });
    }

    // handleChange = (e) => {
    //     let name = e.target.name;
    //     let value = e.target.value;
    //     if (name === 'currentDate') {
    //         this.setState({ currentDate: value })
    //     }

    // }
    handleChange = (e) => {
        let name = e.target.name;
        let value = e.target.value;
        if (name === 'startDate') {
            let date = this.state.ChapterMemberCountTablesReportsRequest
            date.startDate = value
            this.setState({ startDate: date })
        }
        if (name === 'endDate') {
            let date = this.state.ChapterMemberCountTablesReportsRequest
            date.endDate = value
            this.setState({ endDate: date })
        }
    }

    validateField = (key) => {
        const newValidState = validate(
            key,
            this.state.ChapterMemberCountTablesReportsRequest,
            this.state.validationRule,
            this.state.validState
        );
        this.setState({ validState: newValidState });
    };
    isValidateAllFields = () => {
        const newValidState = isValidForm(
            this.state.ChapterMemberCountTablesReportsRequest,
            this.state.validationRule,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };
    render() {
        return (
            <div className="main-body-section finance-body-sec">
                <div className="bg-white">
                    <div className="grid grid-cols-12 gap-6 w-full items-center px-8 py-10">
                    <div className="col-span-3">
                            <label
                                className="block text-xl font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                                htmlFor="default"
                            >
                                Start Date<span className="text-[#C00000]">*</span>
                            </label>
                            <div className="">
                                <input
                                    id="startDate"
                                    name="startDate"
                                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                    type="date"
                                    value={moment(this.state.ChapterMemberCountTablesReportsRequest.startDate).format("yyyy-MM-DD")}
                                    onChange={(event) => this.handleChange(event)}
                                    onBlur={() => this.validateField("startDate")}
                                />
                            </div>
                            <ValidationText error={this.state.validState.error.startDate} />
                        </div>
                        <div className="col-span-3">
                            <label
                                className="block text-xl font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                                htmlFor="default"
                            >
                                End Date<span className="text-[#C00000]">*</span>
                            </label>
                            <div className="">
                                <input
                                    id="endDate"
                                    name="endDate"
                                    className="date-pickers form-input rounded-none w-full shadow-red py-3 text-lg"
                                    type="date"
                                    value={moment(this.state.ChapterMemberCountTablesReportsRequest.endDate).format("yyyy-MM-DD")}
                                    onChange={(event) => this.handleChange(event)}
                                    onBlur={() => this.validateField("endDate")}
                                // min={this.state.transactionRecordRequest.startDate}
                                />
                            </div>
                            <ValidationText error={this.state.validState.error.endDate} />
                        </div>
                       
                        <div className="col-span-3">
                            <label
                                className="block text-xl font-medium 2xl:mb-1 lg:[0.25rem] theme-color min-h-30"
                                htmlFor="default"
                            >
                                Member Status<span className="text-[#C00000]">*</span>
                            </label>
                            <div className="input">
{/* 
                                <Selector
                                options={this.state.statusList}
                                // isMulti
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                // components={{
                                //   Option,
                                // }}
                                onChange={this.handleChangeInDropdown.bind(this)}
                                allowSelectAll={false}
                                //value={this.state.paymentCategory.find(item => item.label === this.state.pagination.paymentCategory)}
                                // value={this.state.organisationRoleList.find(
                                //     (item) =>
                                //       item.label === this.state.pagination.organisationRoleStatus
                                //   )}
                                value={this.state.statusData}
                                drpIdentity="status"
                                /> */}
                                <Selector
                                    options={this.state.statusList}
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    onChange={this.handleChangeInDropdown.bind(this)}
                                    allowSelectAll={false}
                                    value={this.state.statusList.filter(item => item.label === this.state.ChapterMemberCountTablesReportsRequest.memberStatus)}
                                    drpIdentity="status"
                                />
                               <ValidationText error={this.state.validState.error.memberStatus} />
                            </div>
                        </div>
                       
                        <div className="col-span-4">
                            <button className="btn btn-red text-xl border text-white mt-8" onClick={() => this.generateChapterMemberCountTableReport()}>
                                Generate Chapter Members Report
                            </button>
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-6 w-full items-center justify-center px-8 py-10">
                        <div className="2xl:col-span-12 lg:col-span-12 col-span-12 w-full">
                            {this.state.isLoading ? <PageLoader /> :
                                <table className="w-full mx-auto my-5 fixed_header batch-job-extraction-table border">
                                    <thead>
                                        <tr className="text-base font-bold flex">
                                            <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[40%]">
                                                <div className="font-bold tble-th-txt text-left">
                                                    Generate Date
                                                </div>
                                            </th>
                                            <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[40%]">
                                                <div className="font-bold tble-th-txt text-left">
                                                    Number of Records
                                                </div>
                                            </th>
                                            <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[40%]">
                                                <div className="font-bold tble-th-txt text-left">
                                                StartDate
                                                </div>
                                            </th><th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[40%]">
                                                <div className="font-bold tble-th-txt text-left">
                                                EndDate
                                                </div>
                                            </th>
                                            <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[40%]">
                                                <div className="font-bold tble-th-txt text-left">
                                                Status
                                                </div>
                                            </th>
                                            <th className="px-2 first:pl-5 last:pr-5 tbl-th whitespace-nowrap text-white w-[20%]">
                                                <div className="font-bold tble-th-txt text-center">Action</div>
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody className="scrollit text-sm custom-tbody">
                                        {this.state.organisationRoleReportList.map((e, key) => {
                                            return (
                                                <tr className="custom-tbl-td flex items-center" key={key}>
                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[40%] ">
                                                        {moment(e.generationDate).format("DD MMM YYYY")}
                                                    </td>
                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[40%]">
                                                        {e.numberOfRecords}
                                                    </td>
                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[40%] ">
                                                        {moment(e.startDate).format("DD MMM YYYY")}
                                                    </td> <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[40%] ">
                                                        {moment(e.endDate).format("DD MMM YYYY")}
                                                    </td>
                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[40%]">
                                                        {e.memberStatus}
                                                    </td>
                                                    <td className="px-2 first:pl-5 last:pr-5 whitespace-nowrap tble-td-txt text-[#757575] w-[20%]">
                                                        <button
                                                            className="action-btn mx-auto flex items-center"
                                                            aria-controls="add-edit-modal"
                                                            onClick={() => {
                                                                this.downloadSheetByChapterMemberTableReportId(e.chapterMemberReportId);
                                                            }}
                                                        >
                                                            <p className="ml-2 tool-tip-txt underline text-[#81a3b8]">
                                                                Download
                                                            </p>
                                                        </button>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            }
                        </div>

                    </div>
                </div>

            </div>
        );
    }
}
